import React from "react";
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import "./PdfEditTocContainer.css";
import { switchZoomAction } from "../../redux/actions/pdfEditTocContainer";
import SinglePdfPageContainer from "../SinglePdfPageContainer/SinglePdfPageContainer";
import TocEditPanel from "../TocEditPanel/TocEditPanel";

class PdfEditTocContainer extends React.Component {
  constructor(props) {
    super(props);
    this.zoomClicked = this.zoomClicked.bind(this);
    this.leftClicked = this.leftClicked.bind(this);
    this.rightClicked = this.rightClicked.bind(this);
    this.leftDoubleClicked = this.leftDoubleClicked.bind(this);
    this.rightDoubleClicked = this.rightDoubleClicked.bind(this);
    this.flipLeft = this.flipLeft.bind(this);
    this.flipRight = this.flipRight.bind(this);
    this.pageEntered = this.pageEntered.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.pdfContainer = React.createRef();
    this.onDoubleClick = this.onDoubleClick.bind(this);

    this.state = {
      leftPage: -10,
      rightPage: -10,
      displayPage: ""
    };
  }

  componentDidMount() {
    this.setPage();
    this.pdfContainer.focus();
  }

  onKeyDown(e) {
    if (e.key === "ArrowLeft") {
      e.view.event.preventDefault();
      this.leftDoubleClicked();
    } else if (e.key === "ArrowRight") {
      e.view.event.preventDefault();
      this.rightDoubleClicked();
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      this.zoomClicked();
    }
  }

  onDoubleClick(e) {
    if (this.pdfContainer == null) {
      return;
    }

    const { switchZoomAction } = this.props;

    const oldPos = this.pdfContainer.getBoundingClientRect();

    const oldScrollX = window.scrollX;
    const oldScrollY = window.scrollY;

    const oldMouseOffsetX = e.clientX - oldPos.x;
    const oldMouseOffsetY = e.clientY - oldPos.y;

    switchZoomAction();

    setTimeout(() => {
      const newPos = this.pdfContainer.getBoundingClientRect();
      const scale = newPos.width / oldPos.width;

      const newMouseOffsetX = oldMouseOffsetX * scale;
      const newMouseOffsetY = oldMouseOffsetY * scale;

      const newScrollX =
        oldScrollX + newMouseOffsetX - oldMouseOffsetX < 0
          ? 0
          : oldScrollX + newMouseOffsetX - oldMouseOffsetX;
      const newScrollY =
        oldScrollY + newMouseOffsetY - oldMouseOffsetY < 0
          ? 0
          : oldScrollY + newMouseOffsetY - oldMouseOffsetY;
      window.scroll(newScrollX, newScrollY);
    }, 0);
  }

  zoomClicked() {
    this.props.switchZoomAction();
  }

  componentDidUpdate(prevProps) {
    if (this.props.issue !== prevProps.issue) {
      this.setPage();
    }
  }

  flipLeft(pageNum) {
    const { issue } = this.props;
    if (issue == null) {
      return;
    }

    const { leftPage } = this.state;

    if (issue.is_left_flip) {
      let newLeftPage = parseInt(leftPage) - pageNum;

      if (newLeftPage < -1) {
        newLeftPage = -1;
      }

      const newRightPage = newLeftPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage,
        displayPage: newLeftPage + 1
      });
    } else {
      let newLeftPage = parseInt(leftPage) + pageNum;

      if (newLeftPage > issue.pages.length) {
        newLeftPage = issue.pages.length;
      }

      const newRightPage = newLeftPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage,
        displayPage: newRightPage + 1
      });
    }
  }

  flipRight(pageNum) {
    const { issue } = this.props;
    if (issue == null) {
      return;
    }

    const { rightPage } = this.state;

    if (issue.is_left_flip) {
      let newRightPage = parseInt(rightPage) + pageNum;

      if (newRightPage > issue.pages.length) {
        newRightPage = issue.pages.length;
      }

      const newLeftPage = newRightPage - 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage,
        displayPage: newLeftPage + 1
      });
    } else {
      let newRightPage = parseInt(rightPage) - pageNum;

      if (newRightPage < -1) {
        newRightPage = -1;
      }

      const newLeftPage = newRightPage + 1;

      this.setState({
        leftPage: newLeftPage,
        rightPage: newRightPage,
        displayPage: newRightPage + 1
      });
    }
  }

  pageEntered(event) {
    const { issue } = this.props;

    if (issue == null) {
      return;
    }

    if (isNaN(event.target.value)) {
      return;
    }

    const newPage = parseInt(event.target.value);

    this.setState({ displayPage: event.target.value });

    if (isNaN(newPage)) {
      return;
    }

    if (newPage < 0 || newPage > issue.pages.length) {
      return;
    }

    if (issue.is_left_flip) {
      this.setState({
        leftPage: newPage - 1,
        rightPage: newPage,
        displayPage: newPage - 1 + 1
      });
    } else {
      this.setState({
        leftPage: newPage,
        rightPage: newPage - 1,
        displayPage: newPage - 1 + 1
      });
    }
  }

  leftClicked() {
    this.flipLeft(1);
  }

  rightClicked() {
    this.flipRight(1);
  }

  leftDoubleClicked() {
    this.flipLeft(2);
  }

  rightDoubleClicked() {
    this.flipRight(2);
  }

  setPage() {
    const { issue } = this.props;

    if (issue == null) {
      this.setState({
        leftPage: -10,
        rightPage: -10,
        displayPage: ""
      });
    } else if (issue.is_left_flip) {
      this.setState({
        leftPage: -1,
        rightPage: 0,
        displayPage: 0
      });
    } else {
      this.setState({
        leftPage: 0,
        rightPage: -1,
        displayPage: 0
      });
    }
  }

  render() {
    const { title, issue } = this.props;
    const { leftPage, rightPage, displayPage } = this.state;

    let showPdf =
      issue != null && displayPage >= 0 && displayPage <= issue.pages.length;
    let showLeft =
      issue != null && leftPage >= 0 && leftPage < issue.pages.length;
    let showRight =
      issue != null && rightPage >= 0 && rightPage < issue.pages.length;

    let enablePagingLeft = false;
    let enablePagingRight = false;

    if (issue != null) {
      if (issue.is_left_flip) {
        enablePagingRight = displayPage < issue.pages.length;
        enablePagingLeft = displayPage > 0;
      } else {
        enablePagingRight = displayPage > 0;
        enablePagingLeft = displayPage < issue.pages.length;
      }
    }

    return (
      <React.Fragment>
        <Row className="toc_utility_section">
          <Col>
            <ButtonGroup className="toc_paging_btns" variant="info">
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingLeft}
                onClick={this.leftDoubleClicked}
              >
                <span className="fa fa-angle-double-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingLeft}
                onClick={this.leftClicked}
              >
                <span className="fa fa-angle-left" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingRight}
                onClick={this.rightClicked}
              >
                <span className="fa fa-angle-right" />
              </Button>
              <Button
                variant="info"
                className="toc_paging_btn"
                disabled={!enablePagingRight}
                onClick={this.rightDoubleClicked}
              >
                <span className="fa fa-angle-double-right" />
              </Button>
            </ButtonGroup>
            <InputGroup
              style={{
                display: "inline-flex",
                width: "150px",
                marginLeft: "15px"
              }}
            >
              <FormControl value={displayPage} onChange={this.pageEntered} />
              <InputGroup.Append>
                <InputGroup.Text>
                  {issue == null ? "" : " / " + issue.pages.length}
                </InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>
        </Row>
        <div
          onDoubleClick={this.onDoubleClick}
          onKeyDown={this.onKeyDown}
          tabIndex="0"
          ref={el => (this.pdfContainer = el)}
        >
          {showPdf && (
            <Row>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                {showLeft && (
                  <SinglePdfPageContainer
                    title={title}
                    issue={issue}
                    inToc={true}
                    isLeft={true}
                    page={leftPage}
                  />
                )}
              </Col>
              <Col xs="12" sm="12" md="6" lg="6" xl="6">
                {showRight && (
                  <SinglePdfPageContainer
                    title={title}
                    issue={issue}
                    inToc={true}
                    isLeft={false}
                    page={rightPage}
                  />
                )}
              </Col>
            </Row>
          )}
        </div>
        {issue != null && (
          <TocEditPanel issue={issue} issueID={issue.id} isPdf={true} />
        )}
      </React.Fragment>
    );
  }
}

const mapDispatch = {
  switchZoomAction
};

export default connect(
  null,
  mapDispatch
)(PdfEditTocContainer);
